<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          USER
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Detail User
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()" title="refresh">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <v-form @submit.prevent="save">
          <v-flex xs12 class="pa-7">
            <v-layout row wrap>
              <table width="50%">
                <tr>
                  <td width="20%">NIK</td>
                  <td width="5%">:</td>
                  <td width="50%" class="textblack--text">
                    {{ items.nik ? items.nik : '-' }}
                  </td>
                </tr>
                <tr>
                  <td width="20%">Email</td>
                  <td width="5%">:</td>
                  <td width="50%" class="textblack--text">
                    {{ items.email ? items.email : '-' }}
                  </td>
                </tr>
                <tr>
                  <td width="20%">Name</td>
                  <td width="5%">:</td>
                  <td width="50%" class="textblack--text">
                    {{ items.name ? items.name : '-' }}
                  </td>
                </tr>
                <tr>
                  <td width="20%">Profile</td>
                  <td width="5%">:</td>
                  <td width="50%" class="textblack--text">
                    <v-chip
                      v-for="(item, index) in items.profiles"
                      :key="index"
                      class="mr-2"
                    >
                      {{ item.desc }}
                    </v-chip>
                  </td>
                </tr>
              </table>
            </v-layout>
          </v-flex>
          <v-card-actions class="text-right">
            <v-spacer></v-spacer>
            <v-flex xs2 right class="mr-4">
              <v-btn
                id="button-back"
                dark
                rounded
                color="red"
                block
                :to="{ name: 'user' }"
              >
                Back
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      name: '',
      loading: true,
      progressDialogLoading: true,
      search: '',
      items: {},
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'User List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'User Detail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      const id = this.id;
      return this.$store.dispatch('auth/detail', { id }).then(data => {
        this.progressDialogLoading = false;
        this.loading = false;
        if (data.code === 200) {
          this.items = data.data;
        } else {
          Swal.fire('Failed!', data.response.data.message.text_en, 'error');
        }
      });
    }
  }
};
</script>
